export default __webpack_public_path__ + "static/media/forcasArmadas.e96635c7.jpg";